import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import axios from 'axios';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Article } from '../models/article.model';
import { AuthService } from './auth.service';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root',
})
export class ArticleService {
  http = inject(HttpClient);
  utilsService = inject(UtilsService);
  logger: NGXLogger = inject(NGXLogger);
  authService = inject(AuthService);
  constructor() {}

  async getArticles(uid: string): Promise<Observable<any>> {
    try {
      const baseParams = new HttpParams().set('uid', uid).set('limit', 3);
      return this.utilsService.setHttpHeaders(false).then((headers) => {
        return this.http.get(environment['AWS_ARTICLE_FETCH']!, {
          params: baseParams,
          headers: headers,
        });
      });
    } catch (error) {
      this.logger.error(`Error fetching articles: ${JSON.stringify(error)}`);
      throw { message: `Error fetching articles: ${error}` };
    }
  }

  async getUploadUrl(uuid: string): Promise<any> {
    return this.utilsService
      .setAxiosHeaders(true)
      .then((headers) => {
        return axios.get<any>(environment['AWS_ARTICLE_SIGNEDURL']!, {
          params: { id: uuid },
          headers: headers,
        });
      })
      .then((response) => {
        return {
          method: 'PUT',
          url: response.data.url,
          headers: {
            'Content-Type': `application/json`,
          },
        };
      });
  }

  async create(article: Partial<Article>): Promise<any> {
    return this.utilsService.setAxiosHeaders(true).then(async (headers) => {
      return axios
        .put(environment['AWS_ARTICLE_CREATE']!, article, { headers: headers })
        .catch((error) => {
          throw error;
        })
        .then((response) => {
          return response.data;
        });
    });
  }

  async update(article: Partial<Article>): Promise<Article> {
    return this.utilsService.setAxiosHeaders(true).then(async (headers) => {
      // this.logger.log('ArticleService:: update:', headers);
      return axios
        .put(environment['AWS_ARTICLE_UPDATE']!, article, { headers: headers })
        .catch((error) => {
          throw error;
        })
        .then((response) => {
          return response.data;
        });
    });
  }

  async delete(id: string): Promise<string> {
    return this.utilsService.setAxiosHeaders(true).then(async (headers) => {
      return axios
        .delete(environment['AWS_ARTICLE_DELETE']!, {
          params: { id: id },
          headers: headers,
        })
        .then((response) => {
          return id;
        });
    });
  }
}
